export default __webpack_public_path__ + "locales/es/DeleteProfileEverDialog.json?hash=d3d63fdd81aaf79b73d603289c7e086e";